import React from 'react';
// Ganti isi <svg> di bawah ini dengan SVG icon custom Anda.
// Pastikan ukuran viewBox="0 0 24 24" agar konsisten dengan icon lain.
export function ClockIcon(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      {/* Contoh isi SVG, silakan ganti dengan SVG Anda */}
      <circle cx="12" cy="12" r="10" fill="#4FF7B6"/>
      <rect x="11" y="6" width="2" height="7" rx="1" fill="#fff"/>
      <rect x="12" y="12" width="5" height="2" rx="1" fill="#fff"/>
    </svg>
  );
} 